import Image from 'app/Components/Shared/Image/image';
import React from 'react';
import {Container, Row} from 'reactstrap';
import insightIcon from '../PortalsBlock/images/icon-insight/icon-120-insight.svg';
import BtnWhite from '../../Shared/Buttons/BtnWhite';
import EpiContext from '@episerver/spa-core/Spa';
import Config from '../../../Config';
import dwhSelfCareSuspendActivateAccount from './dwhReports';

const DtonlyPopup = (props) => {
  dwhSelfCareSuspendActivateAccount({
    actionType: 'Action Selection',
    status: 'Ongoing',
    messageText: 'DTONLY subscription about to reopen',
    ...props.params,
  });

  const handleClick = async (action) => {
    await props.onClickActionButton(action, 'CR');
  };
  return (
    <Container fluid>
      <div className='client-information-change-hetPay-text'>
        <Row className='justify-content-center'>
          <Image src={insightIcon} alt='התראה' />
        </Row>
        <Row className='justify-content-center'>
          <span className='title'>שימו לב</span>
        </Row>
        <Row className='justify-content-center'>
          <span className='content'>{props.content}</span>
        </Row>
      </div>
      <Row className='justify-content-center mt-2'>
        <button
          className='btn-submit-purple'
          onClick={() => {
            handleClick('activate');
          }}>
          המשך
        </button>
      </Row>
      <Row className='justify-content-center mt-2'>
        <BtnWhite
          isBusiness
          text={`חזרה לאיזור האישי`}
          onclick={() => {
            EpiContext.navigateTo(Config.businessLobbyUrl);
          }}
        />
      </Row>
    </Container>
  );
};

export default DtonlyPopup;
